import { Button, Popconfirm, Tag } from 'antd';
import React from 'react';
import { User } from '../../types/users';
import ChangeRoleButton from './ChangeRoleButton';

const UserOverviewTableColumns = (onDelete: (user: User) => any, onChangeRole: () => any) => {
  return [
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
      render: (text: string) => <span>{text}</span>,
      sorter: (user1: User, user2: User) => (user1.username > user2.username ? 1 : -1),
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: (role: string) => (
        <Tag color={`${role === 'ADMIN' ? 'green' : ''}`}>{role === 'ADMIN' ? 'ADMIN' : 'USER'}</Tag>
      ),
      sorter: (user1: User, user2: User) => {
        if (!user1.role) return 1;
        if (!user2.role) return -1;
        if (user1.role > user2.role) {
          return -1;
        }
        return 1;
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 200,
      render: (text: string, record: User) => {
        return (
          <>
            <span>
              <ChangeRoleButton username={record.username} role={record.role || ''} onChangeRole={onChangeRole} />
            </span>
            <span className="mx-2">|</span>
            <span>
              <Popconfirm
                title={
                  <>
                    Are you sure to delete this user <strong>{record.username}</strong>?
                  </>
                }
                onConfirm={() => onDelete(record)}
                okText="Yes"
                cancelText="No">
                <Button type="link" className="m-0 p-0">
                  Delete
                </Button>
              </Popconfirm>
            </span>
          </>
        );
      },
    },
  ];
};

export default UserOverviewTableColumns;
